// Gates ALL browser-console output behind REACT_APP_DEBUG_VERBOSE — the client
// counterpart of the server's DEBUG_VERBOSE. Must be the FIRST import in
// index.js so it runs before anything logs and before Faro snapshots/patches
// the console.
//
//   REACT_APP_DEBUG_VERBOSE=true   -> console behaves exactly as before (dev/testing)
//   unset / anything else          -> log/info/debug/warn/error/trace print nothing
//
// Create React App bakes REACT_APP_* in at build time, so production builds
// that don't set it are silent. Grafana Faro is unaffected: telemetry.js hands
// Faro a silent "unpatched console", so Faro still captures info/warn/error
// (its default levels) but the user's browser prints nothing.
const METHODS = ["log", "info", "debug", "warn", "error", "trace"];
const noop = () => {};

export const isConsoleVerbose = process.env.REACT_APP_DEBUG_VERBOSE === "true";

export const silentConsole = METHODS.reduce((acc, m) => {
  acc[m] = noop;
  return acc;
}, {});

if (!isConsoleVerbose && typeof console !== "undefined") {
  METHODS.forEach((m) => {
    console[m] = noop;
  });
}
